<script setup lang="ts">
import { onMounted } from 'vue';
import { onBeforeUnmount } from 'vue';
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useAddressBookStore } from '@/store/addressBook';
import AddressRecentList from '@/components/organisms/AddressRecentList.vue';

const addressBookStore = useAddressBookStore();
defineProps<{
  variant?: 'solo-filled' | 'outlined';
  color?: string;
  disableShortcut?: boolean;
}>();

const router = useRouter();
const input = ref('');
const search = ref<InstanceType<any>>();
const menuOpen = ref(false);

function onKeyUpEnter(event: KeyboardEvent) {
  if (input.value.trim().length == 0) {
    event.stopPropagation();
    return;
  }

  // Avoid re-open the menu when clicking on the button
  if (event.type === 'click') {
    event.stopPropagation();
  }

  router.push({
    name: 'Portfolio',
    params: {
      addresses: input.value.trim(),
    },
  });
  menuOpen.value = false;
  input.value = '';
  search.value.blur();
}

function onDocumentKeydown(e: KeyboardEvent) {
  if (e.key === 'Escape') {
    input.value = '';
    search.value.blur();
  }
  if ((document.activeElement as any)?.type === 'text') return;
  if (e.key === '/') {
    e.preventDefault();
    search.value.focus();
  }
}

onMounted(() => {
  document.addEventListener('keydown', onDocumentKeydown);
});
onBeforeUnmount(() => {
  document.removeEventListener('keydown', onDocumentKeydown);
});
</script>

<template>
  <v-text-field
    ref="search"
    style="max-width: 500px"
    v-model="input"
    hide-details
    :variant="variant || 'solo-filled'"
    :color="color"
    :base-color="color"
    density="compact"
    single-line
    @keyup.enter="onKeyUpEnter"
    autocorrect="off"
    autocapitalize="off"
    autocomplete="off"
    enterkeyhint="search"
    class="search-field"
  >
    <template #label>Search address or domain</template>

    <template #append-inner>
      <v-btn
        @click="onKeyUpEnter"
        :color="color"
        size="small"
        class="rounded-s-0 rounded-e-lg"
        icon="mdi-magnify"
        variant="tonal"
      />
    </template>
    <v-menu
      activator="parent"
      v-if="addressBookStore.recentItems.length > 0"
      v-model="menuOpen"
    >
      <address-recent-list density="default" />
    </v-menu>
  </v-text-field>
</template>
